module.exports = __webpack_public_path__ + "img/emptystate-medical-conditions.52f0f19c.svg";